<template>
  <div class="profile-avatar-placeholder w-[67px] h-[67px] rounded-full bg-line text-ink/60 shrink-0 overflow-hidden" aria-hidden="true">
    <svg width="67" height="67" viewBox="0 0 67 67" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
      <circle cx="33.5" cy="33.5" r="32.75" vector-effect="non-scaling-stroke"/>
      <g transform="translate(33.5 33.5) scale(2.7291666667) translate(-14 -14)">
        <circle cx="14" cy="11" r="4" vector-effect="non-scaling-stroke"/><path d="M6 23c0-4 3.6-6 8-6s8 2 8 6" vector-effect="non-scaling-stroke"/>
      </g>
    </svg>
  </div>
</template>
